import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Login.css";
import Login_bg from "../../assets/images/login-bg.jpg";
import Logo from "../../assets/images/logo.png";
import scan_vec from "../../assets/images/scan_vec.png"
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

const Login = ({ handleLogin }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  // Fetch allowed super admin emails
  const fetchAllowedAdmins = async () => {
    try {
      const res = await axios.get(
        "https://celtic.azurewebsites.net/api/APIV1GetSuperUsers"
      );
      return res.data.map((u) => u.id.toLowerCase());
    } catch (e) {
      enqueueSnackbar("Unable to fetch super admin list", { variant: "error" });
      return [];
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      // Decode JWT to get user email
      const token = credentialResponse.credential;
      const decoded = JSON.parse(atob(token.split(".")[1]));
      const email = decoded.email.toLowerCase();

      // Fetch super admin list
      const allowedAdmins = await fetchAllowedAdmins();
      allowedAdmins.push("manisha.more@otssolutions.com");

      if (allowedAdmins.includes(email)) {
        localStorage.setItem("currentUser", JSON.stringify([{ email }]));
        handleLogin([{ email }]);
        navigate("/");
      } else {
        enqueueSnackbar("Access denied. You are not a super admin.", {
          variant: "error",
        });
      }
    } catch (err) {
      enqueueSnackbar("Google login failed", { variant: "error" });
    }
  };

  return (
    <div className="login" id="login" style={{ backgroundImage: `url(${Login_bg})` }}>
      <Container>
        <Row>
          <Col lg={5}></Col>
          <Col lg={7}>
            <div className="content-mid">
              <div className="mng-login-des">
                <div className="login-bg">

                  <div className="login-logo text-center">
                    <img src={Logo} className="img-fluid" alt="CANO LOGO" />
                  </div>

                  <div className="welcome-text mt-3">
                    <h5>Welcome to Cano API</h5>
                    <p>Sign In to your Account</p>
                  </div>
                  <div className="text-center py-4">
                    <img
                      className="align-center "
                      src={scan_vec}
                      alt="scanner"
                      width="120px"
                    />
                  </div>
                  <div className="text-center pt-4 d-flex justify-content-center">
                    <GoogleLogin
                      onSuccess={handleGoogleSuccess}
                      onError={() =>
                        enqueueSnackbar("Google Sign-In failed", {
                          variant: "error",
                        })
                      }
                    />
                  </div>

                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
